module.exports = __webpack_public_path__ + "static/media/YM01_4.14f37017.jpg";